import React from "react";
import Chart from "react-apexcharts";
import {isNumber} from "@turf/turf";

const GaugeChartPreview = ({
                               height,
                               minValue,
                               maxValue,
                               currentValue,
                               showValue,
                               valuePosition,
                               gaugeColor,
                               gaugeColorSecondary,
                               remainingColor,
                               fontSize,
                               fontFamily,
                               chartWidth
                           }) => {
    const percentage = ((currentValue - minValue) / (maxValue - minValue)) * 100;

    // Configuración de ApexCharts
    const options = {
        chart: {
            type: "radialBar",
            height: height,
            width: "100%", // El ancho se ajustará automáticamente
        },
        plotOptions: {
            radialBar: {
                startAngle: -135,
                endAngle: 135,
                hollow: {
                    margin: 15,
                    size: isNumber(chartWidth) ? `${chartWidth}%` : "70%",
                    background: "transparent",
                    dropShadow: {
                        enabled: false,
                    },
                },
                track: {
                    background: '#' + (remainingColor.replace('#', '')),
                    strokeWidth: "97%",
                },
                dataLabels: {
                    show: showValue,
                    name: {
                        show: valuePosition === "outside",
                        fontSize: fontSize + "px",
                        color: "#333",
                        offsetY: valuePosition === "center" ? -30 : -10,
                    },
                    value: {
                        show: true,
                        fontSize: fontSize + "px",
                        fontWeight: "bold",
                        fontFamily: fontFamily,
                        color: '#' + (gaugeColor.replace('#', '')),
                        offsetY: valuePosition === "center" ? 10 : 40,
                        formatter: function (val) {
                            return `${Math.round(val)}%`;
                        },
                    },
                },
            },
        },
        colors: ['#' + (gaugeColor.replace('#', ''))],
        responsive: [
            {
                breakpoint: 768,
                options: {
                    chart: {
                        height: "auto",
                    },
                },
            },
        ],
    };

    // Serie con el porcentaje calculado
    const series = [percentage];

    return (
        <div style={{ width: "100%" }}> {/* Aseguramos el ancho al 100% */}
            <Chart options={options} series={series} type="radialBar" height={height} />
        </div>
    );
};

export default GaugeChartPreview;
